/*!
 * Copyright © 2021. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ETrackingDeviceEventCode, LatLng } from '../../core/models';

export interface IAssetLocationHistoryResponseDto {
  locationsHistory: IAssetLocationsHistoryDto[];
  totalDisplayRecords: number;
  totalRecords: number;
}

export interface IAssetLocationsHistoryDto {
  gpsUpdateUtc: string;
  eventCode: ETrackingDeviceEventCode;
  gpsQuality: EGPSQuality;
  address: string;
  coordinates: {
    latitude: number;
    longitude: number;
  };
}

export interface IAssetLocationsHistory {
  gpsUpdateUtc: Date;
  eventCode: ETrackingDeviceEventCode;
  gpsQuality: EGPSQuality;
  address: string;
  latlng: LatLng;
}

export interface IAssetLocationHisoryRequestDto {
  assetTrackingId: string;
  dbId: number;
  startFromDaysAgo: number;
  startDate: Date;
  endDate: Date;
  offset: number;
  numberOfRows: number;
}

export enum EGPSQuality {
  Lost = 1,
  Low = 2,
  Normal = 3
}
